import { environmentBase } from "./environment.base";

const envTmp = {...environmentBase};
envTmp.appFrontend.tenantId = '61daf269-4b40-4169-94a5-999b4441ef3e';
envTmp.appFrontend.clientId = '08e4920c-c32c-4451-929c-641f1eaec345';
envTmp.appFrontend.redirect.url = 'https://erp.dev.tksl.net/login';
envTmp.appFrontend.postLogoutRedirect.url = 'https://erp.dev.tksl.net/login';
envTmp.appFrontend.modules.administracion.active = false;
envTmp.appFrontend.modules.soporte.active = false;
envTmp.appBackend.clientId = '487a2ab4-1096-43e6-a802-7f359ab2da29';
envTmp.appBackend.apiUrlBase = 'https://api.erp.dev.tksl.net/api';
envTmp.mode = 'dev';

export const environment = {...envTmp};